// extracted by mini-css-extract-plugin
module.exports = {"masterLoaderWrapper":"style_masterLoaderWrapper__VrvNw","isFullPageMasterLoader":"style_isFullPageMasterLoader__NONsH"};